// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dashboard Footer Styles */
.dashboard-footer {
  background: var(--neutral-800);
  color: var(--neutral-200);
  margin-top: 2rem;
  padding: var(--space-4) 0;
  border-top: 1px solid var(--neutral-700);
}

.footer-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 var(--space-4);
  display: flex;
  justify-content: center;
  align-items: center;
}

.footer-copyright {
  text-align: center;
}

.footer-copyright p {
  color: var(--neutral-400);
  font-size: var(--text-sm);
  font-weight: var(--font-medium);
  margin: 0;
  line-height: 1.5;
}

/* Responsive Design */
@media (max-width: 768px) {
  .dashboard-footer {
    padding: var(--space-3) 0;
  }

  .footer-content {
    padding: 0 var(--space-3);
  }
}

@media (max-width: 480px) {
  .dashboard-footer {
    padding: var(--space-2) 0;
  }

  .footer-content {
    padding: 0 var(--space-2);
  }

  .footer-copyright p {
    font-size: var(--text-xs);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/dashboard/DashboardFooter.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;EAC/B,SAAS;EACT,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/* Dashboard Footer Styles */\n.dashboard-footer {\n  background: var(--neutral-800);\n  color: var(--neutral-200);\n  margin-top: 2rem;\n  padding: var(--space-4) 0;\n  border-top: 1px solid var(--neutral-700);\n}\n\n.footer-content {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 0 var(--space-4);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.footer-copyright {\n  text-align: center;\n}\n\n.footer-copyright p {\n  color: var(--neutral-400);\n  font-size: var(--text-sm);\n  font-weight: var(--font-medium);\n  margin: 0;\n  line-height: 1.5;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .dashboard-footer {\n    padding: var(--space-3) 0;\n  }\n\n  .footer-content {\n    padding: 0 var(--space-3);\n  }\n}\n\n@media (max-width: 480px) {\n  .dashboard-footer {\n    padding: var(--space-2) 0;\n  }\n\n  .footer-content {\n    padding: 0 var(--space-2);\n  }\n\n  .footer-copyright p {\n    font-size: var(--text-xs);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
